// utils/navigation.js

export const goToDashboard = (navigate) => {
  const role = localStorage.getItem('userType')?.toLowerCase();

  switch (role) {
    case 'admin':
      navigate('/admin/dashboard');
      break;
    case 'recruteur':
      navigate('/recruteur/dashboard');
      break;
    case 'entreprise':
      navigate('/entreprise/dashboard');
      break;
    case 'agent':
      navigate('/agent/dashboard');
      break;
    case 'commercial':
      navigate('/commercial/dashboard');
      break;
    case 'candidat':
      navigate('/candidat/dashboard');
      break;
    default:
      navigate('/');
      break;
  }
};
